import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { CollectiveAgreementHasDietTypeDto } from "@/core/features/collective-agreements-have-diet-types/collective-agreement-has-diet-type.dto";
import { Transform, Type } from "class-transformer";
import { toEuros, toHours } from "@/utils/numberUtils";
import { CollectiveAgreementWeekendDayEnum } from "@altertec_gparn/lib";

export class CollectiveAgreementDto extends BaseEntityDto {
  name: string;

  holidayDaysPerYear: number;

  default?: boolean;

  archived: boolean;

  @Type(() => CollectiveAgreementHasDietTypeDto)
  collectiveAgreementHasDietTypes?: CollectiveAgreementHasDietTypeDto[];

  zoneCoding?: string;

  @Transform(({ value }) => toHours(value))
  numberOfHours: number;

  @Transform(({ value }) => toEuros(value))
  exemptKmPrice: number;

  @Transform(({ value }) => toEuros(value))
  taxableKmPrice: number;

  weekendDays: CollectiveAgreementWeekendDayEnum[];

  toString(): string {
    return this.name;
  }
}
